module.exports = __webpack_public_path__ + "img/125.6.970d2ee7.png";